import { createStructuredSelector } from "reselect";
import {
    RAZONABILIDAD_PRICE,
    RAZONABILIDAD_PRICE_SUCCESS,
    RAZONABILIDAD_PRICE_ERROR,
    RAZONABILIDAD_PRICE_MODAL_SET,
    RAZONABILIDAD_PRICE_SEARCH_SET,
    RAZONABILIDAD_PRICE_SEARCH_CHANGE,
    RAZONABILIDAD_PRICE_DATA_SET,
    RAZONABILIDAD_PRICE_DATA_CHANGE,
    RAZONABILIDAD_PRICE_DATA_TABLE,
    ARTICLE_YEAR_RAZONABILIDAD,
    ARTICLE_YEAR_RAZONABILIDAD_SUCCESS,
    ARTICLE_YEAR_RAZONABILIDAD_ERROR,
    SOURCE_RAZONABILIDAD,
    SOURCE_RAZONABILIDAD_SUCCESS,
    SOURCE_RAZONABILIDAD_ERROR
} from "../actions";

export const NAME = 'razonabilidad';

export const RazonabilidadPrice = (filters) => ({
    type: RAZONABILIDAD_PRICE,
    payload: { filters: filters}
});

export const RazonabilidadPriceSuccess = (data) => ({
    type: RAZONABILIDAD_PRICE_SUCCESS,
    payload: data
});

export const RazonabilidadPriceError = (error) => ({
    type: RAZONABILIDAD_PRICE_ERROR,
    payload: error
});

export const RazonabilidadPriceModalSet = (data) => ({
    type: RAZONABILIDAD_PRICE_MODAL_SET,
    payload: data
});

export const RazonabilidadPriceSearchSet = (data) => ({
    type: RAZONABILIDAD_PRICE_SEARCH_SET,
    payload: data
});

export const RazonabilidadPriceSearchChange = (data) => ({
    type: RAZONABILIDAD_PRICE_SEARCH_CHANGE,
    payload: data
});

export const RazonabilidadPriceDataSet = (data) => ({
    type: RAZONABILIDAD_PRICE_DATA_SET,
    payload: data
});

export const RazonabilidadPriceDataChange = (data) => ({
    type: RAZONABILIDAD_PRICE_DATA_CHANGE,
    payload: data
});

export const RazonabilidadPriceDataTable = (data) => ({
    type: RAZONABILIDAD_PRICE_DATA_TABLE,
    payload: data
});

export const ArticleYearRazonabilidad = (filters) => ({
    type: ARTICLE_YEAR_RAZONABILIDAD,
    payload: { filters: filters }
});

export const ArticleYearRazonabilidadSuccess = (data) => ({
    type: ARTICLE_YEAR_RAZONABILIDAD_SUCCESS,
    payload: data
});

export const ArticleYearRazonabilidadError = (error) => ({
    type: ARTICLE_YEAR_RAZONABILIDAD_ERROR,
    payload: error
});

export const SourceRazonabilidad = (filters) => ({
    type: SOURCE_RAZONABILIDAD,
    payload: { filters: filters }
});

export const SourceRazonabilidadSuccess = (data) => ({
    type: SOURCE_RAZONABILIDAD_SUCCESS,
    payload: data
});

export const SourceRazonabilidadError = (error) => ({
    type: SOURCE_RAZONABILIDAD_ERROR,
    payload: error
});


const razonabilidad = (state) => state[NAME];

export const RazonabilidadSelector = createStructuredSelector({
    razonabilidad
})
